class FreeShippingBadge extends HTMLElement {
  connectedCallback() {
    this.thresholdCents = parseInt(this.dataset.thresholdCents, 10);
    this.unitPriceCents = parseInt(this.dataset.unitPriceCents, 10);

    this.quantityInput = document.querySelector('quantity-input:not(.hidden) input[name="quantity"]');
    this.bundleRoot = document.querySelector('product-bundle');
    // .lb-widget-bl is the theme-rendered app-block wrapper — it exists in the
    // initial page HTML. <lb-upsell-widget> and everything inside it are
    // injected later, asynchronously, by Selleasy's own script (after it
    // fetches offer data), so it does NOT exist yet when this script runs.
    // Querying inside this.selleasyWrapper lazily (in getSelleasyAddonsCents,
    // on every recalculate) instead of caching <lb-upsell-widget> up front is
    // what lets this pick up Selleasy's content once it finally appears.
    this.selleasyWrapper = document.querySelector('.lb-widget-bl');

    if (this.quantityInput) {
      this.quantityInput.addEventListener('change', () => this.recalculate());
    }

    if (this.bundleRoot) {
      const bundleTotalEl = this.bundleRoot.querySelector('[data-bundle-product-total]');
      if (bundleTotalEl) {
        const observer = new MutationObserver(() => this.recalculate());
        observer.observe(bundleTotalEl, { childList: true, characterData: true, subtree: true });
      }
    }

    if (this.selleasyWrapper) {
      const observer = new MutationObserver(() => this.recalculate());
      observer.observe(this.selleasyWrapper, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['lb-default-price'],
      });
    }

    this.recalculate();
  }

  getQuantity() {
    if (!this.quantityInput) return 1;
    const qty = parseInt(this.quantityInput.value, 10);
    return qty > 0 ? qty : 1;
  }

  getBundleItemPriceCents(item) {
    const selectElement = item.querySelector('select[name="group_id"]');
    const inputElement = item.querySelector('input[name="group_id"]');
    let price;

    if (selectElement) {
      price = selectElement.options[selectElement.selectedIndex].getAttribute('data-price');
    } else if (inputElement) {
      price = inputElement.getAttribute('data-price');
    } else {
      const idInput = item.querySelector('input[name="id"]');
      price = idInput ? idInput.getAttribute('data-price') : null;
    }

    return price ? parseFloat(price) : 0;
  }

  getNativeBundleTotalCents() {
    if (!this.bundleRoot) return 0;

    const checkedItems = this.bundleRoot.querySelectorAll('.bundle-product-item.isChecked');
    const allItems = this.bundleRoot.querySelectorAll('.bundle-product-item');
    let total = 0;

    checkedItems.forEach((item) => {
      total += this.getBundleItemPriceCents(item);
    });

    const discountEl = this.bundleRoot.querySelector('.bundle-price[data-bundle-discount-rate]');
    if (discountEl && allItems.length > 0 && checkedItems.length === allItems.length) {
      const discountRate = parseFloat(discountEl.getAttribute('data-bundle-discount-rate'));
      total = total * (1 - discountRate);
    }

    return total;
  }

  getSelleasyAddonsCents() {
    if (!this.selleasyWrapper) return 0;

    const totalPriceEl = this.selleasyWrapper.querySelector('.lb-bundle-cta-total-cont .lb-price-sale-price');
    if (!totalPriceEl) return 0;

    const selleasyTotalCents = parseInt(totalPriceEl.getAttribute('lb-default-price'), 10);
    if (isNaN(selleasyTotalCents)) return 0;

    // Selleasy's own total already includes this page's main product once
    // (its trigger card has no quantity control of its own). Subtract
    // Selleasy's own cached price for that trigger card — not this.unitPriceCents
    // — so the math stays internally consistent even if the theme's and
    // Selleasy's price caches ever drift apart (recent price change, stale
    // app sync, etc).
    const triggerPriceEl = this.selleasyWrapper.querySelector('lb-upsell-flat-card[trigger-card] .lb-price-sale-price');
    const triggerPriceCents = triggerPriceEl
      ? parseInt(triggerPriceEl.getAttribute('lb-default-price'), 10)
      : this.unitPriceCents;

    const addonsOnly = selleasyTotalCents - triggerPriceCents;
    return addonsOnly > 0 ? addonsOnly : 0;
  }

  getBundleTotalCents() {
    return this.getNativeBundleTotalCents() + this.getSelleasyAddonsCents();
  }

  recalculate() {
    const totalCents = (this.unitPriceCents * this.getQuantity()) + this.getBundleTotalCents();
    this.render(totalCents);
  }

  render(totalCents) {
    if (totalCents >= this.thresholdCents) {
      this.innerHTML = '<span class="free-ship-badge free-ship-badge--progress" role="status" aria-label="Você ganhou frete grátis!"><span aria-hidden="true">🚚</span> <span>Você ganhou <strong>frete grátis!</strong></span></span>';
    } else {
      const remaining = Shopify.formatMoney(this.thresholdCents - totalCents, window.money_format);
      this.innerHTML = '<span class="free-ship-badge free-ship-badge--progress" role="status" aria-label="Faltam ' + remaining + ' para Frete Grátis"><span aria-hidden="true">🚚</span><span>Faltam ' + remaining + ' para <strong>Frete Grátis</strong></span></span>';
    }
  }
}

customElements.define('free-shipping-badge', FreeShippingBadge);
